export default "/images/phone-off.svg?b18e4ae142ee0d8930a86cb42cd4d1d1";